import React from 'react';
import ReactPlayer from 'react-player';

import RotatingGrid from 'components/images/RotatingGrid';
import ResponsiveImage from 'components/images/ResponsiveImage';
import {
  BlackSlide,
  BigText,
  MedText,
  PhotoRow,
  PlayerWrapper,
  Row,
  ScrollSection
} from '../styles';

import { welcomeGrid } from 'data/rotatingImages';

const SectionOne = ({ revealed }) => {
  return (
    <React.Fragment>
      <BlackSlide className="swiper-slide" revealed>
        <h1 className="quote">
          ROW DTLA has shown Los Angeles what happens when you redefine the concept of placemaking
          for retail, dining and culture, and that if you celebrate innovation, collaboration and
          community, you get something very special, that just keeps getting better.
        </h1>
        <span className="scroll-reminder">
          <p>SCROLL</p>
        </span>
      </BlackSlide>
      <ScrollSection className="swiper-slide" paddingLeft="160px" revealed={revealed >= 0}>
        <PhotoRow>
          <ResponsiveImage
            srcPath="/images/pages/home/section_1/ROWDTLA_retail-brochure_section1_1"
            imgAlt="test"
          />
        </PhotoRow>
        <Row height="45%">
          <BigText className="black-500">
            Welcome to
            <br />
            ROW DTLA
          </BigText>
        </Row>
      </ScrollSection>
      <ScrollSection className="swiper-slide" revealed={revealed >= 1}>
        <PhotoRow>
          <ResponsiveImage
            srcPath="/images/pages/home/section_1/ROWDTLA_retail-brochure_section1_2"
            imgAlt="test"
          />
        </PhotoRow>
        <Row height="45%">
          <MedText className="grey-400">
            A 32 acre district with a 100 year old
            <br />
            history marks the beginning of LA’s
            <br />
            future as the new retail, cultural and
            <br />
            dining destination. By pairing unique
            <br />
            retailers and distinct individuals
            <br />
            together, a historic area comes to life
            <br />
            by way of an elevated lifestyle
          </MedText>
        </Row>
      </ScrollSection>
      <ScrollSection className="swiper-slide" revealed={revealed >= 2}>
        <PlayerWrapper>
          <ReactPlayer
            className="react-player"
            width="100%"
            height="100%"
            url="https://vimeo.com/357861717"
            playing
            controls
            light="/video/player/rowdtla_video_preview_general.jpg"
          />
        </PlayerWrapper>
      </ScrollSection>
      <ScrollSection className="swiper-slide" revealed={revealed >= 3}>
        <PhotoRow>
          <ResponsiveImage
            srcPath="/images/pages/home/section_1/ROWDTLA_retail-brochure_section1_3"
            imgAlt="test"
          />
        </PhotoRow>
        <Row height="45%">
          <BigText className="grey-400">
            The revitalization of an
            <br />
            urban district happens
            <br />
            at the crossroads of
            <br />
            creativity and culture
          </BigText>
        </Row>
      </ScrollSection>
      <ScrollSection className="swiper-slide" paddingRight="0" revealed={revealed >= 4}>
        <ResponsiveImage
          srcPath="/images/pages/home/section_1/ROWDTLA_retail-brochure_section1_4"
          imgAlt="test"
        />
      </ScrollSection>
      <ScrollSection className="swiper-slide" paddingRight="120px" revealed={revealed >= 5}>
        <Row height="55%" />
        <Row height="45%">
          <MedText marginTop>
            Within an already bustling
            <br />
            downtown, ROW infuses even
            <br />
            more energy into the
            <br />
            neighborhood
          </MedText>
        </Row>
      </ScrollSection>
      <ScrollSection className="swiper-slide" paddingRight="120px" revealed={revealed >= 6}>
        <RotatingGrid imgGrid={welcomeGrid} carouselActive={revealed >= 6} />
      </ScrollSection>
      <ScrollSection className="swiper-slide" revealed={revealed >= 7}>
        <PhotoRow>
          <ResponsiveImage
            srcPath="/images/pages/home/section_1/ROWDTLA_retail-brochure_section1_17"
            imgAlt="test"
          />
        </PhotoRow>
        <Row height="45%">
          <MedText>
            An international and local blend
            <br />
            of like-minded artists, designers,
            <br />
            chefs and merchants interacting
            <br />
            together in a walkable work, shop,
            <br />
            eat and play community.
          </MedText>
        </Row>
      </ScrollSection>
      <ScrollSection className="swiper-slide" paddingRight="180px" revealed={revealed >= 8}>
        <ResponsiveImage
          srcPath="/images/pages/home/section_1/ROWDTLA_retail-brochure_section1_18"
          imgAlt="test"
        />
      </ScrollSection>
    </React.Fragment>
  );
};

export default SectionOne;
